export default {
	logout: 'logout',
}